import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_map_x12_5010_940_to_datex_order_infoService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { XML?: string, Data?: $frontendTypes.FootprintEdi.DatexMapInfo }): Promise<{ DatexOrderInfo?: $frontendTypes.FootprintEdi.DatexOrderInfo }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

